module.exports = __webpack_public_path__ + "static/media/audio-blue.e0367e7c.png";